import { Collapse, } from "antd";

const { Panel } = Collapse;

const Accordion = () => {
    return (

        <Collapse defaultActiveKey={["1"]} accordion>
            {/* <Panel
                header="Estímulos a la creatividad en el espacio público"
                key="1"
                extra={
                    <Checkbox
                        indeterminate={indeterminate}
                        onChange={onCheckAllChange}
                        checked={checkAll}
                    />
                }
            >
                <Checkbox.Group
                    options={plainOptions}
                    value={checkedList}
                    onChange={onChangeCheck}
                />
            </Panel> */}
            <Panel header="Medellín vive las artes" key="2">
                a
            </Panel>
            <Panel
                header="Estímulo a la apropiación creativa de nuestro patrimonio vivo"
                key="3"
            >
                <p>a</p>
            </Panel>
            <Panel header="Festival de Tango" key="4">
                <p>a</p>
            </Panel>
            <Panel header="Festival Altavoz" key="5">
                <p>a</p>
            </Panel>
            <Panel
                header="Estímulos para la promoción y distribución de largometrajes y cortometrajes"
                key="6"
            >
                <p>a</p>
            </Panel>
        </Collapse>

    );
};
export default Accordion